<template>
  <section id="professional-location" v-if="professional.latitude">
    <div class="professional-section-title mb-3">
      <span v-if="$i18n.locale === 'en'">
        {{ professional.name | firstName }}{{ $t('message.professional.neighborhood') }}
      </span>
      <span v-else>
        {{ $t('message.professional.neighborhood') }} {{ professional.name | firstName }}
      </span>
    </div>
    <div class="embed-responsive embed-responsive-16by9 rounded-all">
      <div class="embed-responsive-item">
        <gmap-map :center="center"
                  :zoom="13"
                  :options="options"
                  style="width: 100%; height: 100%;">
          <gmap-circle :center="center" :radius="1000" :options="mapCenterOptions"/>
        </gmap-map>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['professional'],
    data () {
      return {
        center: {lat: this.professional.latitude, lng: this.professional.longitude},
        options: {
          clickableIcons: false,
          gestureHandling: 'cooperative',
          zoomControlOptions: {position: 3},
          maxZoom: 15,
          scrollwheel: false
        },
        mapCenterOptions: {
          strokeColor: '#00BCD4',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#00BCD4'
        }
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    watch: {
      professional () {
        this.center = {lat: this.professional.latitude, lng: this.professional.longitude}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/CleanerMap.vue